/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Dbvalue.css';
import ReactEcharts from 'echarts-for-react'







class Dbvalue extends React.Component {


  constructor(props){
    super(props)
    this.state={}
    this.getOption=this.getOption.bind(this)
  }
  getOption=()=>{
    var data = [];
    for (var i = 0; i < 4; i++) {
      data[i] = [];
    }
    // var datadb = [100, 200, 300, 400]
    // let datadb={
    //   "tt": 77,
    //   "wx": 385,
    //   "wb": 308,
    //   "items": [
    //   7863315,
    //   6290652,
    //   4717989,
    //   1572663
    //   ],
    //   "zh": 231,
    //   "db": 20444619
    // }
    let datadb=this.props.json||{
        "db": 20444619,
        "tt": 77,
        "tt_db": 77,
        "wb": 308,
        "wb_db": 308,
        "wx": 385,
        "wx_db": 385,
        "zh": 231,
        "zh_db": 231,
      }
    // console.log(this.props,datadb,'dbdbdbdbd图')

    

    
    var percentage = ['30%', '30%', '30%', '30%']
    let wx=datadb.wx==0?-1:datadb.wx
    let wb=datadb.wb==0?-1:datadb.wb
    let tt=datadb.tt==0?-1:datadb.tt
    let zh=datadb.zh==0?-1:datadb.zh

    for (var i = 0; i <= wx; i++) {
      var t = 2 * i * Math.PI / 360;
      let a = i * 200 * 200 / 360
      let r = Math.sqrt(a)
      //data[0].push([r*Math.cos(t), r*Math.sin(t)]);
      let c=datadb.wx_db<0?'1':'0'

      data[0].push([Math.sqrt(Math.random(i)), i % 360,c]);
      // 			data[1].push([Math.sqrt(Math.random(i)), i % 360]);
      // 			data[2].push([Math.sqrt(Math.random(i)), i % 360]);
      // 			data[3].push([Math.sqrt(Math.random(i)), i % 360]);
    }
    
    
    for (var i = 0; i <= wb; i++) {
      let c=datadb.wb_db<0?'1':'0'
      
      data[1].push([Math.sqrt(Math.random(i)), i % 360,c]);
    }
    
    for (var i = 0; i <= tt; i++) {
      let c=datadb.tt_db<0?'1':'0'
      
      data[2].push([Math.sqrt(Math.random(i)), i % 360,c]);
    }
    for (var i = 0; i <= zh; i++) {
      let c=datadb.zh_db<0?'1':'0'
      
      data[3].push([Math.sqrt(Math.random(i)), i % 360,c]);
    }
 
    // console.log(data[0],data[1],data[2],data[3])

    var title = ['微信', '微博', '今日头条', '知乎'];
    // console.log(title)
    var polar = [];
    var angleAxis = [];
    var radiusAxis = [];
    var series = [];
    var center=[['20%','55%'],['40%','55%'],['60%','55%'],['80%','55%']]
    for (var i = 0; i < data.length; i++) {
      polar.push({
        // center: [20 + 50 * (i % 2) + '%', (25 + 45 * Math.floor(i / 2)) + '%'],
        center:center[i],
        radius: percentage[i]
      });
      angleAxis.push({
        show: false,
        polarIndex: i,
        type: 'value',
        startAngle: 0,
      });
      radiusAxis.push({
        show: false,
        polarIndex: i,
        min: 0,
      });
      series.push({
        polarIndex: i,
        coordinateSystem: 'polar',
        name: title[i],
        type: 'scatter',
        showSymbol: false,
        label: {
          normal: {
            show: false,
            position: 'bottom'
          }
        },
        data: data[i].map(function(node){
          let color 

          if(node[2]==1){
            color='#ccc'
          }
          // console.log(node,color)
          return{
            value:[node[0],node[1]],
            itemStyle:{
              normal:{
                color:color
              }
            }
          }

        })
      });
    }
     const option = {
      color: ['#c2e1c5', '#fac8a7', '#f1b1ad' ,'#abd9f2'],
    
      toolbox: {
        right:20,
        show: true,
        feature: {
          mark: { show: true },
          //          dataView : {show: true, readOnly: false},
          magicType: {
            show: true,
            type: ['pie', 'funnel']
          },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      title: {
        text: `${this.props.db?'DB值':'DB总值'} - ${this.props.items.name}`,
        subtext:'数据来源：数字品牌榜',
        // sublink:'',
        x: '20'
      },
      polar: polar,
      legend: {
        data: ['微信', '微博',  '今日头条','知乎'],
        bottom: '35',
        right: '20',
        orient: 'vertical',
        selectedMode: false
      },
      tooltip: {
        show: false
      },
      angleAxis: angleAxis,
      radiusAxis: radiusAxis,
      series: series,
      animationDuration: 2000,
      graphic: [{
        type: 'text',
        id: 'text1',
        z: 100,
        left: '13.8%',
        top: '74%',
        style: {
          fill: '#333',
          text: [
            '微信：' + parseFloat(datadb.wx_db).toLocaleString()||0
          ],
          font: '16px Microsoft YaHei'
        }
      },
      {
        type: 'text',
        id: 'text2',
        z: 100,
        left: '34.5%',
        top: '74%',
        style: {
          fill: '#333',
          text: [
            '微博：' + parseFloat(datadb.wb_db).toLocaleString()||0
          ],
          font: '16px Microsoft YaHei'
        }
      },
      {
        type: 'text',
        id: 'text3',
        z: 100,
        left: '54%',
        top: '74%',
        style: {
          fill: '#333',
          text: [
            '今日头条：' + parseFloat(datadb.tt_db).toLocaleString()||0
          ],
          font: '16px Microsoft YaHei'
        }
      },
      {
        type: 'text',
        id: 'text4',
        z: 100,
        left: '76%',
        top: '74%',
        style: {
          fill: '#333',
          text: [
            '知乎：' + parseFloat(datadb.zh_db).toLocaleString()||0
          ],
          font: '16px Microsoft YaHei'
        }
      }, {
        type: 'text',
        id: 'text5',
        z: 100,
        left: '43%',
        top: '25%',
        style: {
          fill: '#333',
          text: [
            `${this.props.db?'DB值':'DB总值'} ` + parseFloat(datadb.db).toLocaleString()||0
          ],
          font: '22px Microsoft YaHei'
        }
      }
      ]
    };
    return option
  
  
  }

 

  render() {
    return (

      <ReactEcharts
        option={this.getOption()}
        style={{
          height: '550px',
          width: '100%',
          
          borderRadius: '4px',

        }}
        className={s.charts}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        onChartReady={this.onChartReadyCallback}
      />
    )



  }
}

export default withStyles(s)(Dbvalue);



// WEBPACK FOOTER //
// src/components/Dbvalue/Dbvalue.js